import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, Star } from "lucide-react";
import { getHoroscopeToday } from "@/lib/api";
import { readMySign, ZODIAC_SIGNS } from "@/lib/readoo";
import { HoroscopeHub } from "@/components/HoroscopeHub";
import { useAuth } from "@/context/AuthContext";
import { EmptyState } from "@/components/Skeletons";

export default function Horoscope() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Oroscopo di oggi · Readoo";
    getHoroscopeToday().then(setData).catch(() => setData(null)).finally(() => setLoading(false));
  }, []);

  const mySign = (user && user.zodiac_sign) || readMySign();
  const myMeta = ZODIAC_SIGNS.find((s) => s.key === mySign);

  return (
    <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles size={18} style={{ color: "#8b5cf6" }} />
        <span className="font-mono text-xs font-bold uppercase tracking-wider" style={{ color: "#8b5cf6" }}>Oroscopo</span>
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl font-semibold text-onSurface">Le stelle di oggi</h1>
      {data?.label && <p className="text-subtle mt-2 capitalize">{data.label}</p>}

      <div className="mt-4 flex flex-wrap gap-3">
        <Link to="/il-mio-segno" data-testid="horoscope-choose-sign" className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold text-white transition-colors" style={{ backgroundColor: "#8b5cf6" }}>
          {myMeta ? <>Il mio segno: {myMeta.emoji} {myMeta.name}</> : <>Scegli il tuo segno</>}
          <ArrowRight size={15} />
        </Link>
        {data?.summary && (
          <Link to={`/articolo/${data.summary.article_id}/oroscopo-riepilogo`} data-testid="horoscope-summary-link" className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border border-hair bg-surfaceSecondary text-onSurface hover:border-brand/50 transition-colors">
            <Star size={15} /> Leggi il riepilogo
          </Link>
        )}
      </div>

      <div className="mt-8">
        {loading ? (
          <div className="animate-pulse space-y-3">
            {Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-14 bg-surfaceSecondary rounded-xl" />)}
          </div>
        ) : !data || !data.signs?.length ? (
          <EmptyState icon={Sparkles} title="Oroscopo in arrivo" subtitle="L'oroscopo del giorno viene generato ogni mattina. Torna tra poco." />
        ) : (
          <HoroscopeHub data={data} mode="summary" />
        )}
      </div>
    </div>
  );
}
